import React, { useState, useEffect } from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { MapPin, Search, Package, Clock, Check, X } from 'lucide-react';

// Simulated InPost pickup points in Spain (in production, this would come from InPost API)
const INPOST_POINTS = [
  // Madrid
  { id: 'MAD001', name: 'InPost Locker - Carrefour Gran Vía', address: 'Gran Vía 32', city: 'Madrid', postal_code: '28013', province: 'Madrid', lat: 40.4200, lng: -3.7025, hours: '24h' },
  { id: 'MAD002', name: 'InPost Locker - Mercadona Princesa', address: 'Calle Princesa 45', city: 'Madrid', postal_code: '28008', province: 'Madrid', lat: 40.4300, lng: -3.7180, hours: '24h' },
  { id: 'MAD003', name: 'InPost Locker - El Corte Inglés Castellana', address: 'Paseo de la Castellana 79', city: 'Madrid', postal_code: '28046', province: 'Madrid', lat: 40.4500, lng: -3.6900, hours: '10:00-22:00' },
  { id: 'MAD004', name: 'InPost Point - Papelería Sol', address: 'Calle Arenal 15', city: 'Madrid', postal_code: '28013', province: 'Madrid', lat: 40.4175, lng: -3.7070, hours: '9:00-21:00' },
  { id: 'MAD005', name: 'InPost Locker - Decathlon La Gavia', address: 'CC La Gavia', city: 'Madrid', postal_code: '28051', province: 'Madrid', lat: 40.3800, lng: -3.6100, hours: '24h' },
  
  // Barcelona
  { id: 'BCN001', name: 'InPost Locker - Diagonal Mar', address: 'Av. Diagonal 3', city: 'Barcelona', postal_code: '08019', province: 'Barcelona', lat: 41.4100, lng: 2.2200, hours: '24h' },
  { id: 'BCN002', name: 'InPost Locker - Carrefour Les Glòries', address: 'Av. Diagonal 208', city: 'Barcelona', postal_code: '08018', province: 'Barcelona', lat: 41.4050, lng: 2.1900, hours: '24h' },
  { id: 'BCN003', name: 'InPost Point - Estanco Gracia', address: 'Carrer Gran de Gràcia 122', city: 'Barcelona', postal_code: '08012', province: 'Barcelona', lat: 41.4030, lng: 2.1560, hours: '8:00-20:00' },
  { id: 'BCN004', name: 'InPost Locker - La Maquinista', address: 'CC La Maquinista', city: 'Barcelona', postal_code: '08030', province: 'Barcelona', lat: 41.4400, lng: 2.1980, hours: '10:00-22:00' },
  
  // Valencia
  { id: 'VLC001', name: 'InPost Locker - Aqua Multiespacio', address: 'Calle Pintor Maella 37', city: 'Valencia', postal_code: '46023', province: 'Valencia', lat: 39.4580, lng: -0.3380, hours: '24h' },
  { id: 'VLC002', name: 'InPost Locker - El Saler', address: 'Autopista del Saler 16', city: 'Valencia', postal_code: '46013', province: 'Valencia', lat: 39.4480, lng: -0.3500, hours: '10:00-22:00' },
  { id: 'VLC003', name: 'InPost Point - Farmacia Central', address: 'Calle Colón 54', city: 'Valencia', postal_code: '46004', province: 'Valencia', lat: 39.4700, lng: -0.3720, hours: '9:00-21:00' },
  
  // Sevilla
  { id: 'SEV001', name: 'InPost Locker - Nervión Plaza', address: 'CC Nervión Plaza', city: 'Sevilla', postal_code: '41005', province: 'Sevilla', lat: 37.3890, lng: -5.9720, hours: '24h' },
  { id: 'SEV002', name: 'InPost Locker - Lagoh', address: 'Palmas Altas', city: 'Sevilla', postal_code: '41012', province: 'Sevilla', lat: 37.3600, lng: -6.0050, hours: '10:00-22:00' },
  
  // Málaga
  { id: 'MAL001', name: 'InPost Locker - Larios Centro', address: 'Av. de la Aurora 25', city: 'Málaga', postal_code: '29002', province: 'Málaga', lat: 36.7200, lng: -4.4350, hours: '24h' },
  { id: 'MAL002', name: 'InPost Locker - Plaza Mayor', address: 'CC Plaza Mayor', city: 'Málaga', postal_code: '29004', province: 'Málaga', lat: 36.7300, lng: -4.4700, hours: '10:00-22:00' },
  
  // Bilbao
  { id: 'BIL001', name: 'InPost Locker - Zubiarte', address: 'CC Zubiarte', city: 'Bilbao', postal_code: '48013', province: 'Vizcaya', lat: 43.2680, lng: -2.9400, hours: '24h' },
  { id: 'BIL002', name: 'InPost Point - Kiosko Indautxu', address: 'Plaza Indautxu 3', city: 'Bilbao', postal_code: '48011', province: 'Vizcaya', lat: 43.2620, lng: -2.9450, hours: '8:00-20:00' },
  
  // Zaragoza
  { id: 'ZGZ001', name: 'InPost Locker - Puerto Venecia', address: 'CC Puerto Venecia', city: 'Zaragoza', postal_code: '50021', province: 'Zaragoza', lat: 41.6150, lng: -0.9100, hours: '24h' },
  { id: 'ZGZ002', name: 'InPost Locker - Gran Casa', address: 'CC Gran Casa', city: 'Zaragoza', postal_code: '50015', province: 'Zaragoza', lat: 41.6700, lng: -0.8900, hours: '10:00-22:00' },
  
  // Alicante
  { id: 'ALC001', name: 'InPost Locker - Gran Alacant', address: 'CC Gran Alacant', city: 'Alicante', postal_code: '03130', province: 'Alicante', lat: 38.2350, lng: -0.5200, hours: '24h' },
  
  // Murcia
  { id: 'MUR001', name: 'InPost Locker - Nueva Condomina', address: 'CC Nueva Condomina', city: 'Murcia', postal_code: '30110', province: 'Murcia', lat: 38.0200, lng: -1.1500, hours: '24h' },
  
  // Palma
  { id: 'PMI001', name: 'InPost Locker - Fan Mallorca', address: 'CC Fan Mallorca', city: 'Palma de Mallorca', postal_code: '07014', province: 'Baleares', lat: 39.5750, lng: 2.6350, hours: '24h' },
];

// Calculate approximate distance (simplified for demo)
const calculateDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

// Get coordinates for a postal code (simplified mapping)
const getCoordinatesForPostalCode = (postalCode) => {
  const prefix = postalCode.substring(0, 2);
  const coords = {
    '28': { lat: 40.4168, lng: -3.7038 }, // Madrid
    '08': { lat: 41.3851, lng: 2.1734 },  // Barcelona
    '46': { lat: 39.4699, lng: -0.3763 }, // Valencia
    '41': { lat: 37.3891, lng: -5.9845 }, // Sevilla
    '29': { lat: 36.7213, lng: -4.4214 }, // Málaga
    '48': { lat: 43.2630, lng: -2.9350 }, // Bilbao
    '50': { lat: 41.6488, lng: -0.8891 }, // Zaragoza
    '03': { lat: 38.3452, lng: -0.4810 }, // Alicante
    '30': { lat: 37.9922, lng: -1.1307 }, // Murcia
    '07': { lat: 39.5696, lng: 2.6502 },  // Baleares
  };
  return coords[prefix] || { lat: 40.4168, lng: -3.7038 }; // Default to Madrid
};

const InPostPointSelector = ({ postalCode, onSelectPoint, selectedPoint, onClose }) => {
  const [searchQuery, setSearchQuery] = useState(postalCode || '');
  const [filteredPoints, setFilteredPoints] = useState([]);
  const [userCoords, setUserCoords] = useState(null);

  useEffect(() => {
    if (postalCode) {
      setSearchQuery(postalCode);
      filterPoints(postalCode);
    }
  }, [postalCode]);

  const filterPoints = (query) => {
    if (!query || query.length < 2) {
      setFilteredPoints([]);
      return;
    }

    // Get user coordinates from postal code
    const coords = getCoordinatesForPostalCode(query);
    setUserCoords(coords);

    // Filter and sort by distance
    const results = INPOST_POINTS
      .map(point => ({
        ...point,
        distance: calculateDistance(coords.lat, coords.lng, point.lat, point.lng)
      }))
      .filter(point => 
        point.postal_code.startsWith(query.substring(0, 2)) ||
        point.city.toLowerCase().includes(query.toLowerCase()) ||
        point.distance < 50 // Within 50km
      )
      .sort((a, b) => a.distance - b.distance)
      .slice(0, 10);

    setFilteredPoints(results);
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    filterPoints(value);
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="w-full max-w-2xl max-h-[80vh] overflow-hidden bg-white">
        {/* Header */}
        <div className="bg-gradient-to-r from-yellow-400 to-yellow-500 p-4 text-white">
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-2">
              <Package className="w-6 h-6" />
              <h2 className="text-xl font-bold">Selecciona tu punto InPost</h2>
            </div>
            <button 
              onClick={onClose}
              className="p-1 hover:bg-white/20 rounded-full transition"
            >
              <X className="w-6 h-6" />
            </button>
          </div>
          <p className="text-sm mt-1 opacity-90">Recoge tu pedido en el punto más cercano</p>
        </div>

        {/* Search */}
        <div className="p-4 border-b">
          <Label htmlFor="inpost-search" className="text-sm text-gray-600">
            Buscar por código postal o ciudad
          </Label>
          <div className="relative mt-1">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
            <Input
              id="inpost-search"
              value={searchQuery}
              onChange={(e) => handleSearch(e.target.value)}
              placeholder="Ej: 28013 o Madrid"
              className="pl-10"
              data-testid="inpost-search"
            />
          </div>
        </div>

        {/* Points list */}
        <div className="overflow-y-auto max-h-[50vh] p-4">
          {filteredPoints.length === 0 ? (
            <div className="text-center py-8 text-gray-500">
              <MapPin className="w-12 h-12 mx-auto mb-3 opacity-30" />
              <p>Introduce tu código postal para ver los puntos cercanos</p>
            </div>
          ) : (
            <div className="space-y-3">
              {filteredPoints.map((point) => (
                <div
                  key={point.id}
                  onClick={() => onSelectPoint(point)}
                  className={`p-4 rounded-lg border-2 cursor-pointer transition-all ${
                    selectedPoint?.id === point.id
                      ? 'border-yellow-400 bg-yellow-50'
                      : 'border-gray-200 hover:border-yellow-300 hover:bg-gray-50'
                  }`}
                  data-testid={`inpost-point-${point.id}`}
                >
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <div className="flex items-center gap-2">
                        <span className={`w-2 h-2 rounded-full ${point.hours === '24h' ? 'bg-green-500' : 'bg-yellow-500'}`} />
                        <h3 className="font-semibold text-gray-800">{point.name}</h3>
                      </div>
                      <p className="text-sm text-gray-600 mt-1">
                        <MapPin className="w-3 h-3 inline mr-1" />
                        {point.address}, {point.postal_code} {point.city}
                      </p>
                      <p className="text-xs text-gray-500 mt-1">
                        <Clock className="w-3 h-3 inline mr-1" />
                        Horario: {point.hours}
                      </p>
                    </div>
                    <div className="text-right">
                      <span className="text-sm font-medium text-yellow-600">
                        {point.distance.toFixed(1)} km
                      </span>
                      {selectedPoint?.id === point.id && (
                        <div className="mt-2">
                          <Check className="w-5 h-5 text-green-500" />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-4 border-t bg-gray-50">
          <div className="flex justify-between items-center">
            <p className="text-sm text-gray-500">
              {filteredPoints.length} puntos encontrados
            </p>
            <div className="flex gap-2">
              <Button variant="outline" onClick={onClose}>
                Cancelar
              </Button>
              <Button 
                onClick={onClose}
                disabled={!selectedPoint}
                className="bg-yellow-500 hover:bg-yellow-600 text-white"
                data-testid="confirm-inpost-point"
              >
                Confirmar punto
              </Button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default InPostPointSelector;
